<template>
  <modal-layout :is-open="isOpen" @close="modalClose">
    <div class="Modal_area Explanation__modal_area">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="クラス詳細モーダルを閉じる"
        @click="modalClose"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner Explanation__modal_inner Explanation__modal_inner--pd_lr">
        <div class="Explanation__class">
          <ul class="Explanation__class_list">
            <li
              v-for="category in listCategories"
              :key="category.id"
              class="Explanation__class_list_box"
              style="text-transform:capitalize;"
            >
              <div
                class="Explanation__class_category"
                :style="`
                  background-image: url(${encodeURI(decodeURI(category.icon_url))});
                  background-color: ${category.background_color};
                  --border-color: ${category.color};
                `"
                :class="showCategories[category.id] ? '_active' : ''"
                @click="toggleShow(category.id)"
              >
                {{ category.name }}
              </div>
              <transition name="collapse">
                <div v-show="showCategories[category.id]" class="Explanation__class_category_list collapse-content">
                  <li
                    v-for="program in filteredPrograms(category.id)"
                    v-show="program.display_status === 1"
                    :key="program.id"
                    class="Explanation__class_list_item"
                    :style="`background-color: ${category.background_color};`"
                  >
                    <img
                      class="Explanation__class_list_sub_img"
                      :src="program.image_url"
                      :alt="program.name"
                    >
                    <div class="Explanation__class_list_subtitle">
                      {{ program.name }}
                      <div
                        :class="`Modal_class_favorite_btn ${program.is_favorite_user ? '_active' : ''}`"
                        @click="change(program)"
                      />
                    </div>
                    <!-- eslint-disable vue/no-v-html -->
                    <p v-html="program.description" />
                    <!-- eslint-enable -->
                  </li>
                </div>
              </transition>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout.vue'
import programcategoryService from '@/services/programcategoryService'

export default {
  name: 'ClassFavoriteList',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listPrograms: {},
      listCategories: [],
      showCategories: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getListPrograms()
    },
    async getListPrograms() {
      const response = await programcategoryService.index()
      this.listPrograms = response.data
      this.listCategories = Array.from(
        new Map(this.listPrograms.map(item => [item.master_mindful_category?.id, item.master_mindful_category])).values()
      ).sort((a, b) => a.id - b.id)
    },
    modalClose() {
      this.$emit('close')
    },
    change(program) {
      program.is_favorite_user = !program.is_favorite_user
      this.$emit('changeCategory', program.id)
    },
    filteredPrograms(categoryId) {
      return this.listPrograms.filter(item => item.master_mindful_category?.id === categoryId)
    },
    toggleShow(categoryId) {
      this.$set(this.showCategories, categoryId, !this.showCategories[categoryId])
    }
  }
}
</script>
